import React, { useState, useEffect } from 'react';
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { AccordionContainer } from 'web/pages/private/CommonPages/Faq/FaqTabsStyled'

const TabOneAccordions = ({ tabContents }) => {
  const [expanded, setExpanded] = useState(false);
  const [selectedTabContents, setSelecctedTabContents] = useState([])

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (tabContents.length !== 0) {
      let tempValue = tabContents.map(val => Object.values(val))
      setSelecctedTabContents(tempValue.flat())
    }
  }, [])

  return (
    <AccordionContainer>
      {selectedTabContents && selectedTabContents.map((val, index) => {
        let sentenceSplit = val.split('Answer:')
        let question = sentenceSplit[0].substr(9, sentenceSplit[0].length)
        let answer = sentenceSplit[1]
        return (
          <Accordion
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography>
                {question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{answer}</Typography>
            </AccordionDetails>
          </Accordion>
        )
      })}
    </AccordionContainer>
  );
}

export default TabOneAccordions;